/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ActiveProductionOrder } from '../../models/active-production-order';

export interface GetActiveOrder$Params {
  workCenterId: number;
}

export function getActiveOrder(http: HttpClient, rootUrl: string, params: GetActiveOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<ActiveProductionOrder>> {
  const rb = new RequestBuilder(rootUrl, getActiveOrder.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ActiveProductionOrder>;
    })
  );
}

getActiveOrder.PATH = '/api/v1/MachineSchedule/{workCenterId}/ActiveOrder';
